import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemText,
  Typography,
  IconButton,
  Box,
  Button,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import * as XLSX from "xlsx";
import { useState } from "react";
import excelIcon from "./../../../assets/images/128px-Microsoft_Office_Excel_(2019–2025).svg.png";

function ErrorsModal({ errorsList, onClose, sucessCount, failCount }) {
  const [isDownloading, setIsDownloading] = useState(false);
  const exportToExcel = () => {
    if (isDownloading) return;
    const worksheet = XLSX.utils.json_to_sheet(
      errorsList.map((error) => ({
        "Task ID": error.taskId,
        "Task Name": error.taskName,
        Error: error.error,
      }))
    );
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Errors");
    XLSX.writeFile(workbook, "task-bulk-activity-errors-list.xlsx");
  };

  return (
    <Dialog open={errorsList?.length > 0} onClose={onClose}>
      <DialogTitle>Errors List</DialogTitle>
      <Box display='flex' justifyItems='center'>
        <DialogTitle color='green'>Success Count:{sucessCount}</DialogTitle>
        <DialogTitle color='secondary'>Failure Count:{failCount}</DialogTitle>
      </Box>
      <Box mr={2} display="flex" justifyContent="flex-end">
        <Tooltip title={isDownloading ? "Downloading..." : "Data Export to Excel"}>
          <span>
            <Button
              onClick={exportToExcel}
              disabled={isDownloading}
              sx={{ minWidth: 40 }}
            >
              <img
                src={excelIcon}
                alt="Export"
                style={{
                  width: 30,
                  height: 30,
                  opacity: isDownloading ? 0.5 : 1,
                  cursor: isDownloading ? "not-allowed" : "pointer",
                }}
              />
            </Button>
          </span>
        </Tooltip>
      </Box>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent>
        <List>
          {errorsList.map((error, index) => (
            <ListItem key={index}>
              <ListItemText
                primary={`Client ID: ${error.clientId}`}
                secondary={
                  <>
                    <Typography variant="body1">Task Name : {error.taskName}</Typography>
                    <Typography variant="body2" color="error">
                      {" "}
                      Error :{error.error}
                    </Typography>
                  </>
                }
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
    </Dialog>
  );
}

export default ErrorsModal;
